import { render, staticRenderFns } from "./CoordinateFrameCard.vue?vue&type=template&id=cea007e8&"
import script from "./CoordinateFrameCard.vue?vue&type=script&lang=js&"
export * from "./CoordinateFrameCard.vue?vue&type=script&lang=js&"
import style0 from "./CoordinateFrameCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports